"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryLocationImage = getPrimaryLocationImage;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
function getPrimaryLocationImage(images) {
    if ((0, isEmpty_1.default)(images)) {
        return "";
    }
    const imageMarketAsPrimary = images.find((image) => image.isFirst);
    if (imageMarketAsPrimary) {
        return imageMarketAsPrimary.url;
    }
    return images.sort((a, b) => a.order - b.order)[0].url;
}
//# sourceMappingURL=getPrimaryLocationImage.js.map